import { Action } from '@ngrx/store';
import { type } from '@app/store/util';
import { ProductPanelInterface } from '@app/core/interfaces';

export const RESET = type('[insurances container] reset');
export const SELECT = type('[insurances product panel resolver] select');

export class Select implements Action {
    readonly type = SELECT;
    constructor(public payload: ProductPanelInterface) {}
}

export class Reset implements Action {
    readonly type = RESET;
    constructor() {}
}

export type ProductPanelActions
    = Select
    | Reset;
